import type { ReactNode } from "react";
import { Component, type ErrorInfo } from "react";

import { Button, Result } from "antd";

import { reportClientError } from "@/utils/observability";

interface P {
  children: ReactNode;
}

interface S {
  error: Error | null;
}

export class RootErrorBoundary extends Component<P, S> {
  constructor(props: P) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error): S {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    reportClientError({
      name: error.name,
      message: error.message,
      stack: error.stack,
      componentStack: info.componentStack ?? "",
    });
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <Result
        status="error"
        title="前台渲染出错"
        subTitle="请刷新页面重试。"
        extra={
          <Button type="primary" onClick={() => window.location.reload()}>
            刷新页面
          </Button>
        }
      />
    );
  }
}
